import { useState, useRef, useEffect } from 'react';
import {
  Backdrop,
  Box,
  Modal,
  Fade,
  Typography,
  CircularProgress,
} from '@mui/material';
import palette from '../theme/palette';

export default function ModalStatusConexao({ abrirModal }) {
  const style = {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: palette.dark.primary,
    borderRadius: 1,
    boxShadow: 24,
    p: 4,
  };
  const timerRef = useRef();

  const [query, setQuery] = useState('progress');

  const [open, setOpen] = useState(false);

  // const handleClose = (event) => setOpen(event);

  const handleQuery = () => {
    const statusServer = JSON.parse(localStorage.getItem('statusServer'));

    if (statusServer === 'open') {
      setQuery('reconectado');
      timerRef.current = window.setTimeout(() => {
        setOpen(false);
      }, 2000);
    } else if (statusServer === 'error') {
      setOpen(true);
      setQuery('progress');
    }
    clearTimeout(handleQuery);
    setTimeout(handleQuery, 1000);
  };

  useEffect(() => {
    clearTimeout(timerRef.current);
  }, []);

  useEffect(() => {
    handleQuery();
  }, [localStorage.getItem('statusServer'), abrirModal]);

  return (
    <Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        // onClose={() => handleClose()}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Typography
              id="transition-modal-title"
              variant="h6"
              component="h2"
              textAlign="center"
            >
              O Servidor não está disponível no momento!
            </Typography>
            <Box
              sx={{
                display: 'flex',
                mt: 4,
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography id="transition-modal-description" sx={{ mr: 5 }}>
                Tentando reconectar
              </Typography>
              <Box>
                {query === 'reconectado' ? (
                  <Typography sx={{ color: palette.success.main }}>
                    Reconectado!
                  </Typography>
                ) : (
                  <Fade
                    in={query === 'progress'}
                    style={{
                      transitionDelay: query === 'progress' ? '800ms' : '0ms',
                    }}
                    unmountOnExit
                  >
                    <CircularProgress />
                  </Fade>
                )}
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </Box>
  );
}
